import React, { useState } from 'react';

const PLATFORM_META = {
  instagram: { label: 'Instagram', hint: 'Token de la API de Instagram/Meta Business' },
  facebook: { label: 'Facebook', hint: 'Token de página de Facebook (Meta Business)' },
  tiktok: { label: 'TikTok', hint: 'API key de TikTok for Business' },
  youtube: { label: 'YouTube', hint: 'API key de Google/YouTube Data' },
  whatsapp_business: { label: 'WhatsApp Business', hint: 'Token permanente de WhatsApp Cloud API' },
  google_business: { label: 'Google Business', hint: 'API key de Google Business Profile' },
};

const emptyForm = { account_handle: '', access_token: '', notes: '' };

export const ClinicSocialPanel = ({ connections = {}, platforms = [], onSave, saving, canManage }) => {
  const [forms, setForms] = useState({});

  const getForm = (platform) => forms[platform] || emptyForm;
  const setField = (platform, field, value) => {
    setForms((prev) => ({ ...prev, [platform]: { ...getForm(platform), [field]: value } }));
  };

  const handleSave = async (platform) => {
    await onSave(platform, getForm(platform));
    setForms((prev) => ({ ...prev, [platform]: { ...getForm(platform), access_token: '' } }));
  };

  return (
    <section className="space-y-5" data-testid="clinic-social-panel">
      <article className="rounded-[28px] border border-white/70 bg-white p-6">
        <p className="text-xs uppercase tracking-[0.24em] text-[#0f766e]">Conexiones de redes</p>
        <h2 className="mt-1 text-xl font-black text-slate-900">Redes sociales de la clínica</h2>
        <p className="mt-1 text-sm text-slate-500">Guarda aquí los accesos y APIs de cada red para trabajar campañas, contenido y estrategia desde un solo lugar.</p>
      </article>
      <div className="grid gap-4 lg:grid-cols-2">
        {platforms.map((platform) => {
          const meta = PLATFORM_META[platform] || { label: platform, hint: 'API key / token' };
          const connection = connections[platform] || {};
          const connected = connection.status === 'conectado';
          const form = getForm(platform);
          return (
            <article key={platform} className="rounded-[24px] border border-white/70 bg-white p-5" data-testid={`clinic-social-card-${platform}`}>
              <div className="flex items-center justify-between">
                <p className="text-sm font-bold text-slate-900">{meta.label}</p>
                <span className={`rounded-full px-3 py-1 text-[10px] font-bold uppercase ${connected ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'}`} data-testid={`clinic-social-status-${platform}`}>
                  {connected ? 'Conectado' : 'Pendiente'}
                </span>
              </div>
              {connection.account_handle && <p className="mt-1 text-xs text-slate-500">Cuenta: <span className="font-semibold text-slate-700">{connection.account_handle}</span></p>}
              {connection.access_token_masked && <p className="mt-0.5 text-xs text-slate-400">Token guardado: {connection.access_token_masked}</p>}
              {canManage ? (
                <div className="mt-3 space-y-2">
                  <input
                    className="w-full rounded-2xl border border-slate-200 px-4 py-2.5 text-sm"
                    placeholder="Usuario / @cuenta"
                    value={form.account_handle}
                    onChange={(event) => setField(platform, 'account_handle', event.target.value)}
                    data-testid={`clinic-social-handle-${platform}`}
                  />
                  <input
                    className="w-full rounded-2xl border border-slate-200 px-4 py-2.5 text-sm"
                    placeholder={meta.hint}
                    value={form.access_token}
                    onChange={(event) => setField(platform, 'access_token', event.target.value)}
                    data-testid={`clinic-social-token-${platform}`}
                  />
                  <input
                    className="w-full rounded-2xl border border-slate-200 px-4 py-2.5 text-sm"
                    placeholder="Notas (contrato, estrategia, frecuencia…)"
                    value={form.notes}
                    onChange={(event) => setField(platform, 'notes', event.target.value)}
                    data-testid={`clinic-social-notes-${platform}`}
                  />
                  <button
                    type="button"
                    onClick={() => handleSave(platform)}
                    className="w-full rounded-full bg-[#0f766e] px-4 py-2.5 text-sm font-semibold text-white disabled:opacity-50"
                    disabled={saving === `social-${platform}`}
                    data-testid={`clinic-social-save-${platform}`}
                  >
                    {saving === `social-${platform}` ? 'Guardando…' : 'Guardar conexión'}
                  </button>
                </div>
              ) : (
                <p className="mt-3 text-xs text-slate-400">Solo lectura para tu rol.</p>
              )}
              {connection.notes && <p className="mt-2 text-xs text-slate-500">📝 {connection.notes}</p>}
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default ClinicSocialPanel;
